import { Injectable, inject } from '@angular/core'
import { Project } from '../../../models/project'
import { ProjectCommandParams, ProjectsApiClient } from '@efp/api' // Assuming you have an API client for Projects
import { ProjectDao } from '../project.dao'
import { firstValueFrom } from 'rxjs'
import { PlanService } from '../../plan.service'

@Injectable()
export class ProjectHttpDao extends ProjectDao {
  private readonly projectApiClient = inject(ProjectsApiClient)

  public async findAllByFavouriteId(favouriteId: number): Promise<Project[]> {
    const response = await firstValueFrom(this.projectApiClient.getAllProjects({ favouriteId }))
    return response.map(PlanService.mapModelToProject)
  }

  public async findOne(projectId: number, includePlans: boolean): Promise<Project | undefined> {
    const response = await firstValueFrom(
      this.projectApiClient.getProject({ projectId, includePlans })
    )
    return PlanService.mapModelToProject(response)
  }

  public async findAll(includePlans: boolean): Promise<Project[]> {
    const response = await firstValueFrom(this.projectApiClient.getAllProjects({ includePlans }))
    return response.map(PlanService.mapModelToProject)
  }

  public async findAllByStockId(stockId: number): Promise<Project[]> {
    const response = await firstValueFrom(this.projectApiClient.getAllProjects({ stockId }))
    return response.map(PlanService.mapModelToProject)
  }

  async create(params: ProjectCommandParams): Promise<number> {
    const response = await firstValueFrom(this.projectApiClient.createProject({ body: params }))
    return response
  }

  public async update(project: Project): Promise<void> {
    const body = {
      defaultPlanSettingsId: project.defaultPlanSettings,
      name: project.name,
      stockId: project.stockId,
      accHubId: project.accHubId,
      accId: project.accId,
    }
    const params = {
      projectId: project.id,
      body,
    }

    await firstValueFrom(this.projectApiClient.putProject(params))
  }

  public async delete(project: Project): Promise<void> {
    await firstValueFrom(this.projectApiClient.deleteProject({ projectId: project.id }))
  }
}
